import React__default, { memo } from 'react';
import styled, { css } from 'styled-components';

/* eslint-disable react/no-array-index-key */
const Spacer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40020072__sc-1sd4q0f-0"
})(["border-inline-end:", ";flex:0 0 auto;margin-inline-end:", ";width:", ";", ""], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => `calc(${theme.spacing.base.default} - 1px + (${theme.controls.height.xsmall.default} / 2))`, ({
  $displayAll
}) => $displayAll && css(["width:", ";"], ({
  theme
}) => `calc((${theme.controls.height.xsmall.default} / 2) - 1px)`));
const DepthSpacer = ({
  depth,
  displayAll
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, new Array(depth).fill(0).map((_unused, index) => /*#__PURE__*/React__default.createElement(Spacer, {
  key: index,
  $displayAll: displayAll
})));
var DepthSpacer$1 = /*#__PURE__*/memo(DepthSpacer);

export { DepthSpacer$1 as D };
//# sourceMappingURL=DepthSpacer-BCh3i-VQ.js.map
